import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { CheckMarkIcon } from "src/icons/quote/CheckMarkIcon";

export const ConfirmButton = (
    {
      title,
      confirmCustomRow
    }: {
      title: string;
      confirmCustomRow: any;
    }
) => {
  return (
    <Tooltip title={title}>
      <IconButton onClick={() => confirmCustomRow()}>
        <CheckMarkIcon/>
      </IconButton>
    </Tooltip>
  );
};
